/**
 * @param {string} raw
 * @returns {boolean}
 */
function isHttpOrHttpsUrl(raw) {
  if (typeof raw !== "string") return false;
  const trimmed = raw.trim();
  if (!trimmed) return false;
  try {
    const parsed = new URL(trimmed);
    return parsed.protocol === "https:" || parsed.protocol === "http:";
  } catch {
    return false;
  }
}

/**
 * Normalizes announcement links for preview and published views.
 * Only http(s) URLs are returned so the destination can be inspected safely.
 *
 * @param {Array<{ label?: string, url?: string }> | null | undefined} links
 * @returns {Array<{ label: string, url: string, showUrl: boolean }>}
 */
export function listAnnouncementLinks(links) {
  if (!Array.isArray(links)) {
    return [];
  }
  /** @type {Array<{ label: string, url: string, showUrl: boolean }>} */
  const result = [];
  for (const item of links) {
    if (!item || typeof item !== "object") {
      continue;
    }
    const url = typeof item.url === "string" ? item.url.trim() : "";
    if (!isHttpOrHttpsUrl(url)) {
      continue;
    }
    const label = typeof item.label === "string" ? item.label.trim() : "";
    const displayLabel = label || url;
    result.push({
      label: displayLabel,
      url,
      showUrl: displayLabel !== url,
    });
  }
  return result;
}

/**
 * @param {Array<{ filename?: string, url?: string, mimeType?: string }> | null | undefined} attachments
 * @returns {Array<{ filename: string, url: string, mimeType: string }>}
 */
export function listAnnouncementAttachments(attachments) {
  if (!Array.isArray(attachments)) {
    return [];
  }
  /** @type {Array<{ filename: string, url: string, mimeType: string }>} */
  const result = [];
  for (const file of attachments) {
    if (!file || typeof file !== "object") {
      continue;
    }
    const url = typeof file.url === "string" ? file.url.trim() : "";
    if (!isHttpOrHttpsUrl(url)) {
      continue;
    }
    const filename = typeof file.filename === "string" ? file.filename.trim() : "";
    const mimeType = typeof file.mimeType === "string" ? file.mimeType.trim() : "";
    result.push({ filename, url, mimeType });
  }
  return result;
}
